@import './cms-market-module.scss';

:host {
  background: var(--cms-semanticColors-container-inverted-weak-background);
}